<div
    class="container onts-tag-groups"
    *ngIf="_siblingPillarReady"
>
    <ng-container *ngFor="let control of _form.controls; index as i">
        <div
            cmpsObservationTagGroup
            [hidden]="
                _value[i].behaviourId == null && !_untaggedTagGroupIsVisible
            "
            [class.uncoachedcmpsObservationTagGroup]="
                _value[i].behaviourId == null
            "
            [class.cmpsObservationTagGroup]="_value[i].behaviourId != null"
            [attr.data-focusTrackingId]="_value[i].trackingId"
            [storePathPrefix]="storePathPrefix"
            [observationId]="observationId"
            [published]="published"
            [displayProperties]="displayProperties"
            [performerId]="performerId"
            [focusSelectionParams]="focusSelectionParams"
            [interactionEntity]="interactionEntity"
            [defaultInteractionTypeId]="defaultInteractionTypeId"
            [defaultNoteCategory]="defaultNoteCategory"
            [allowedActions]="allowedActions"
            [behaviours]="behaviours"
            [subBehaviours]="subBehaviours"
            [metrics]="metrics"
            [isGeneric]="isGeneric"
            [activeMetric]="activeMetric"
            [(isCollapsed)]="_isCollapsedState[i]"
            (selectFocus)="_onSelectFocus($event)"
            (copyNotes)="_onCopyNotes($event)"
            (upsertCommitment)="upsertCommitment.emit($event)"
            [extraOptions]="extraOptions"
            [formControl]="control"
        ></div>
    </ng-container>
</div>
